var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                staticClass: "table-mini",
                attrs: {
                  bordered: "",
                  striped: "",
                  responsive: "",
                  items: _vm.columnas,
                  fields: _vm.fields,
                  "show-empty": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(business_term)",
                    fn: function (row) {
                      return [
                        _vm._v(
                          _vm._s(_vm.searchBusinessterm(row.item.business_term))
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(navigator)",
                    fn: function (row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              id: "popover-reactive-" + row.index,
                              variant: "outline-primary",
                              size: "sm",
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "pencil" } }),
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  target: "popover-reactive-" + row.index,
                                  triggers: "hover blur",
                                },
                              },
                              [_vm._v("Assign business term")]
                            ),
                            _c(
                              "b-popover",
                              {
                                ref: "popover-reactive-" + row.index,
                                attrs: {
                                  id: "popover-reactive-" + row.index,
                                  target: "popover-reactive-" + row.index,
                                  triggers: "click blur",
                                  placement: "auto",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          label: "Domain",
                                          "label-cols": "6",
                                        },
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.selectBusinessDomain,
                                            size: "sm",
                                          },
                                          model: {
                                            value: _vm.kdomain,
                                            callback: function ($$v) {
                                              _vm.kdomain = $$v
                                            },
                                            expression: "kdomain",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          label: "Subdomain",
                                          "label-cols": "6",
                                        },
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.filterSubdomain,
                                            size: "sm",
                                          },
                                          model: {
                                            value: _vm.ksubdomain,
                                            callback: function ($$v) {
                                              _vm.ksubdomain = $$v
                                            },
                                            expression: "ksubdomain",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          label: "Business Term",
                                          "label-cols": "6",
                                        },
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.filterBusinessterm,
                                            size: "sm",
                                          },
                                          model: {
                                            value: _vm.input1Return,
                                            callback: function ($$v) {
                                              _vm.input1Return = $$v
                                            },
                                            expression: "input1Return",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-right" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCloseBusinessTerm(
                                                  row.index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Cancel")]
                                        ),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onOkBusinessTerm(
                                                  row.index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Ok")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              id: "popover-reacDel-" + row.index,
                              disabled: _vm.readonly,
                              variant: "outline-primary",
                              size: "sm",
                            },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "trash-fill" } }),
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  target: "popover-reacDel-" + row.index,
                                  triggers: "hover blur",
                                },
                              },
                              [_vm._v("delete business term")]
                            ),
                            _c(
                              "b-popover",
                              {
                                ref: "popover-reacDel-" + row.index,
                                attrs: {
                                  target: "popover-reacDel-" + row.index,
                                  triggers: "click blur",
                                  placement: "auto",
                                  id: "popover-reacDel-" + row.index,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "close",
                                              attrs: { "aria-label": "Close" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onCloseDeleteBusinesTerm(
                                                    row.index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "d-inline-block",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [_vm._v("×")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            " Do you want to unassign the business term?"
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onCloseDeleteBusinesTerm(
                                              row.index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Cancel")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOkDeleteBusinessTerm(
                                              row.index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Ok")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("b-form-group", {
                staticStyle: { "font-size": "0.7rem" },
                attrs: { label: _vm.leyenda, "label-class": "cp-legend-note" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.readonly
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    { attrs: { size: "sm" }, on: { click: _vm.onCancel } },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("cancel"),
                      ]),
                      _vm._v("Cancel"),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "active ml-2",
                      attrs: {
                        id: "popover-save",
                        type: "submit",
                        variant: "primary",
                        size: "sm",
                      },
                      on: { click: _vm.onSubmit },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("send"),
                      ]),
                      _vm._v("Save"),
                      _c("b-tooltip", { attrs: { target: "popover-save" } }, [
                        _vm._v("Save business terms"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }